import React from 'react'
import { AuctionLightProvider } from './AuctionLightContext'
import { CompaniesProvider } from './CompaniesContext'
import { HolidaysProvider } from './HolidaysContext'
import { ReserveQueueContextProvider } from './ReserveQueueContext'
import { SchemaProvider } from './SchemaContext'
import { SchemaPreferenceMigration } from './SchemaPreferenceMigration'
import { TranslatorProvider } from './StatusTranslatorContext'
import { UpdateSchemaProvider } from './UpdateSchemaContext'
import { WaitingFilesCountProvider } from './WaitingFilesCountContext'

const PrivateRouteProvider: React.FC<React.PropsWithChildren<unknown>> = ({ children }) => {
  return (
    <WaitingFilesCountProvider>
      <CompaniesProvider>
        <AuctionLightProvider>
          <TranslatorProvider>
            <SchemaProvider>
              <ReserveQueueContextProvider>
                <HolidaysProvider>
                  <UpdateSchemaProvider>
                    <SchemaPreferenceMigration />
                    {children}
                  </UpdateSchemaProvider>
                </HolidaysProvider>
              </ReserveQueueContextProvider>
            </SchemaProvider>
          </TranslatorProvider>
        </AuctionLightProvider>
      </CompaniesProvider>
    </WaitingFilesCountProvider>
  )
}

export default PrivateRouteProvider
